import e from "react";
import { Camera as E } from "@olxbr/ds-icons";
import { Video as u } from "./Video.js";
import { cls as _ } from "../../helpers/cls.js";
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const i = _ref => {
  let {
    currentImage: n,
    imagesCount: a,
    currentVideo: r,
    videosCount: t,
    className: m,
    hideNumbers: d = !1,
    hideIcons: o = !1
  } = _ref;
  const l = n ? "".concat(n, " / ").concat(a) : a,
    c = r ? "".concat(r, " / ").concat(t) : t,
    s = d && t;
  return !a && !t ? e.createElement(e.Fragment, null) : e.createElement("div", {
    className: _("olx-ad-media-counter", m),
    "data-ds-component": "DS-AdMediaCounter"
  }, !!a && e.createElement("div", null, !o && !s && e.createElement("div", {
    "data-testid": "camera-icon"
  }, e.createElement(E, {
    size: 16
  })), !d && e.createElement("span", {
    "aria-label": "Quantidade de fotos: ".concat(a)
  }, l)), !!t && e.createElement("div", null, !o && e.createElement("div", {
    "data-testid": "video-icon"
  }, e.createElement(u, {
    size: 16
  })), !d && e.createElement("span", {
    "aria-label": "Quantidade de v\xEDdeos: ".concat(t)
  }, c)));
};
i.displayName = "AdMediaCounter";
export { i as AdMediaCounter };